import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Vision from './components/Vision';
import Stats from './components/Stats';
import CaseStudies from './components/CaseStudies';
import TechStack from './components/TechStack';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './App.css';

const API_URL = process.env.NODE_ENV === 'production' 
  ? '/api' 
  : 'http://localhost:5000/api';

function App() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API_URL}/stats`)
      .then(response => {
        setStats(response.data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching stats:', error);
        setStats({ clients: 500, countries: 25, repeatBusiness: 83, hoursOfCode: 25000 });
        setLoading(false);
      });
  }, []);

  return (
    <div className="App">
      <Navbar />
      <Hero />
      <Vision />
      {!loading && <Stats stats={stats} />}
       <CaseStudies />
      <TechStack />
      <FAQ />
      <Contact apiUrl={API_URL} /> 
      <Footer />
    </div>
  );
}

export default App;